import classnames from 'classnames';
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import DropdownButton from 'dpl/components/ResponsiveSelect/DropdownButton';

const VARIANTS = {
  // Figma "Button_Dropdown": a full-width row, 20px sides, 48px tall. The
  // menu sizes to its widest label, so the right side also makes room for
  // the check: 20px inset + 32px bubble + 8px gap.
  dropdown: {
    row: 'pv4 pl5 pr15 fw-medium lh-1',
    selected: 'bg-gray-100',
    check: 'pr5',
    bubble: 'flex items-center justify-center',
    bubbleStyle: { width: '32px', height: '32px' }
  },
  sheet: {
    row: 'pv4 ph7 fw-medium',
    selected: 'bg-near-white',
    check: 'pr7',
    bubble: 'ph2 pv2',
    bubbleStyle: undefined
  }
};

// exp_search_results_sort (CORE-6547): marks the active sort. If the variant
// wins, fold `isSelected` into DropdownButton and delete this wrapper.
export default function SortOptionButton({
  option,
  isSelected,
  onChange,
  variant
}: {
  option: { value: string; label: string };
  isSelected: boolean;
  onChange: (value: string) => void;
  variant: keyof typeof VARIANTS;
}) {
  const styles = VARIANTS[variant];

  return (
    <div className="relative">
      <DropdownButton
        className={classnames(styles.row, { [styles.selected]: isSelected })}
        option={option}
        onChange={onChange}
      />
      {isSelected && (
        <span
          className={classnames(
            'absolute top-0 bottom-0 right-0 flex items-center pointer-events-none',
            styles.check
          )}
        >
          <span
            className={classnames(
              'br-100 bg-white green-500-light',
              styles.bubble
            )}
            style={styles.bubbleStyle}
          >
            <Icon name="fetch-success" width="20px" height="20px" />
          </span>
        </span>
      )}
    </div>
  );
}
